import _get from 'lodash/get';
import { Value } from '@lib/interfaces/form';

export default function getPhoneNumberValueFromQueryData(data?: object) {
  const phone = _get(data, 'phoneNumber.international');
  const country = _get(data, 'phoneNumber.country');
  const countryCode = _get(data, 'phoneNumber.countryCode');
  const number = _get(data, 'phoneNumber.number');
  return {
    country,
    countryCode,
    phone,
    number,
  } as Value;
}
